import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
export var EOrderBookTabs;
(function (EOrderBookTabs) {
    EOrderBookTabs["NOTAUTHORIZED"] = "NotAuthorized";
    EOrderBookTabs["AUTHORIZED"] = "Authorized";
})(EOrderBookTabs || (EOrderBookTabs = {}));
export var orderBookTabs = [
    { title: "Not Authorized ", eventKey: EOrderBookTabs.NOTAUTHORIZED },
    { title: "Authorized", eventKey: EOrderBookTabs.AUTHORIZED },
];
export var orderBookFilterSort = [
    { title: "Sort", eventKey: "Sort" },
    { title: "Filters", eventKey: "Filters" },
];
export var orderBookRows = {
    quantity: "0 / 10",
    limitprice: "423.05",
    triggerprice: "NA",
};
export var sortlistorderbook = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "Alphabetical",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
        },
        {
            title: "Action",
            key: "Action",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
        },
        {
            title: "Expiry",
            key: "Expiry",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
        },
        {
            title: "OrderModified",
            key: "OrderModified",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
        },
    ]),
];
export var fundFiltersorderbook = [
    {
        filterName: "Action",
    },
    {
        filterName: "Product Type",
        list: [
            { title: "CNC", key: "CNC", selected: false },
            { title: "NRML", key: "NRML", selected: false },
            { title: "MTF", key: "MTF", selected: false },
            { title: "MIS", key: "MIS", selected: false },
            { title: "BO", key: "BO", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Order Status",
        list: [
            { title: "Open", key: "Open", selected: false },
            { title: "Completed", key: "Completed", selected: false },
            { title: "Cancelled", key: "Cancelled", selected: false },
            { title: "Rejected", key: "Rejected", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Order Last modified",
        list: [
            { title: "3 Months", key: "three", selected: false },
            { title: "6 Months", key: "six", selected: false },
            { title: "9 Months", key: "nine", selected: false },
            { title: "Select Date Range", key: "date", selected: false },
        ],
        selectType: "checkbox",
    },
];
export var authorizeRow = {
    scriptname: "Tata Motors Ltd.",
    holdingqant: "1000",
    status: "Not Authorized",
    extraRow: "",
};
export var maxSelectedScript = 100;
export var authorizeColumn = [
    {
        columnName: "Stocks",
        arrows: false,
        key: "symbol",
    },
    {
        columnName: "Scrip Name",
        arrows: false,
        key: "symbolName",
    },
    {
        columnName: "Holding Quantity",
        arrows: false,
        key: "quantity",
    },
    {
        columnName: "Status",
        arrows: false,
        key: "status",
        key2: "bseSym",
        key3: "nseSymbol",
    },
];
// authorize history
export var authorizeselltabmobile = [
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
    {
        scriptname: "YES BANK",
        scriptdesc: "Yes Bank Ltd.",
        holdingstatus: "Not Authorised",
        holdingqty: "1000",
    },
];
export var ToasterMsg;
(function (ToasterMsg) {
    ToasterMsg["MIN_LIMIT"] = "Select at least 1 scrip to proceed to authorize";
    ToasterMsg["MAX_LIMIT"] = "You can only add up to 100 scrips at a time";
})(ToasterMsg || (ToasterMsg = {}));
export var AuthSellNavigationState;
(function (AuthSellNavigationState) {
    AuthSellNavigationState["EDIS"] = "EDIS";
})(AuthSellNavigationState || (AuthSellNavigationState = {}));
export var sortlistorder = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "symbolName",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
    ]),
];
